import { CONNECTION_POINTS_STATUSES_LOAD, CONNECTION_POINTS_STATUSES_LOAD_SUCCESS, CONNECTION_POINT_STATUS_LOAD, CONNECTION_POINT_STATUS_LOAD_SUCCESS, CONNECTION_POINTS_STATUSES_LOAD_ERROR, CONNECTION_POINT_STATUS_LOAD_ERROR, CONNECTION_POINT_DELETE_SUCCESS } from './connectionPoints.constants';
import { ConnectionPointTestResult } from '../../models';
import { StoreItem, copy } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

export function connectionPointsStatusesReducer(state: StoreItem<ConnectionPointTestResult> = new StoreItem<ConnectionPointTestResult>(), action: { type: string, payload: any }) {
    let newState = state;
    if (action && action.type) {
        switch (action.type) {
            case CONNECTION_POINTS_STATUSES_LOAD:
                newState = copy(newState);
                newState.isLoading = true;
                break;
            case CONNECTION_POINT_STATUS_LOAD:
                newState = copy(newState);
                const status = newState.dictionary[action.payload.guid];
                if (status) {
                    status.isLoading = true;
                }
                break;
            case CONNECTION_POINT_STATUS_LOAD_SUCCESS:
                newState = copy(newState);
                newState.dictionary[action.payload.guid] = action.payload.test;
                break;
            case CONNECTION_POINTS_STATUSES_LOAD_SUCCESS:
                const list = action.payload;
                const objects = {};
                list.forEach(element => {
                    objects[element.guid] = element;
                });
                newState = {
                    dictionary: objects,
                    isLoading: false,
                    isLoaded: true,
                    hasError: false,
                    error: null
                };
                break;
            case CONNECTION_POINT_DELETE_SUCCESS:
                newState = copy(state);
                delete (newState.dictionary[action.payload.guid]);
                break;
            case CONNECTION_POINTS_STATUSES_LOAD_ERROR:
            // case CONNECTION_POINT_STATUS_LOAD_ERROR:
                newState = copy(newState);
                newState.isLoading = false;
                newState.isLoaded = false;
                newState.hasError = true;
                break;
            case APPLICATION_DISCONNECTED:
                newState = new StoreItem<ConnectionPointTestResult>();
                break;
        }
    }
    return newState;
}